import { render, staticRenderFns } from "./AddressSearchComponent.vue?vue&type=template&id=5ba11cb4&"
import script from "./AddressSearchComponent.vue?vue&type=script&lang=js&"
export * from "./AddressSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressSearchComponent.vue?vue&type=style&index=0&id=5ba11cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports